import {formInputs} from "./inputs";
import {formParsing} from "./parsing";
import {formValidation} from "./validation";
import {formWatching} from "./watching";

export const formComponent = ($r, $formGroups, modifiers) => {
    const self = formInputs($r, $formGroups, modifiers);
    Object.assign(self, formParsing(self, modifiers));
    Object.assign(self, formValidation(self, modifiers));
    Object.assign(self, formWatching(self, modifiers));

    //console.log(self);
    return self;
};